import { SOCIAL_NETWORK, TPost } from '../../models/post'
import Roles from '../../models/roles'
import { TPostSocialManagePost, TLatestSchedule } from '../managePost/newTypes'

export enum SETTING_NAME {
  SINGLE_ROUND_INTERNAL_APPROVE = 'single-round-internal-approve',
  POST_MASTER_CONTENT_SOCIAL_NETWORK_ID = 'post-master-content-social-network-id',
  PROJECT_TIMEZONE = 'project-timezone',
  BYPASS_EXTERNAL_APPROVAL_WHEN_INTERNAL_APPROVED = 'bypass-external-approval-when-internal-approved',
  SKIP_APPROVAL_AND_SCHEDULE = 'skip-approval-and-schedule',
  CONTENT_MANAGER = 'content-manager'
}

export type TPostForApproval = TPost & {
  post_socials: TPostSocialManagePost[]
  latest_schedule: TLatestSchedule
}

export interface IProjectState {
  currentProject: TProject
  availableSocialNetworks: SOCIAL_NETWORK[]
  loaders: TProjectLoaders
  pendingApprovalsCount: Array<any>
  checkResult: string
}

export type TProject = {
  id: number
  name: string
  agency_id: number
  owner_id: number
  logo_image_link: string | null
  timezone: string
  socials: (
    | TProjectSocialFacebook
    | TProjectSocialInstagram
    | TProjectSocialLinkedin
    | TProjectSocialTwitter
  )[]
  role: Roles
  postsToApproval: TPostForApproval[]
  approvedPosts: TPostForApproval[]
  projectUsers: TProjectUser[]
  setting:Array<TProjectSetting>
}

export type TProjectSetting = { 
  id:number,
  name:string,
  value:boolean | string
}

type TProjectLoaders = {
  project: {
    update: boolean
    delete: boolean
  }
  users: {
    delete: boolean
  }
  approval: {
    loading: boolean
  }
}

export type TUserSetting = {
  name:string,
  value:boolean|string
}

export type TProjectUser = {
  id: number
  name: string
  email: string
  role: Roles
  avatar_image_link: string | null
  setting:Array<TUserSetting>
}

export type TProjectSocialFacebook = {
  project_id: number
  social_network_id: number
  social_network: SOCIAL_NETWORK
  account_details: TFacebookOrInstagramAccountDetails
  token_expires_at: number
  id: number
  logo: string
}

export type TLinkedinAccountDetails = {
  role: string
  organization: string
  roleAssignee: string
  state: string
  organizationName: string
  roleAssigneeLastName: string
  roleAssigneeFirstName: string
}

export type TFacebookOrInstagramAccountDetails = {
  fb_page_id: number
  fb_page_name: string
  ig_user_id: number
}

export type TProjectSocialInstagram = {
  project_id: number
  social_network_id: number
  social_network: SOCIAL_NETWORK
  social_uid: number
  social_user_name: string
  social_page_id: number
  social_page_name: string
  token_expires_at: number
  account_details: TFacebookOrInstagramAccountDetails
  id: number
  logo: string
  pages: TPage[]
}

export type TProjectSocialLinkedin = {
  project_id: number
  social_network_id: number
  social_network: SOCIAL_NETWORK
  account_details: TLinkedinAccountDetails
  token_expires_at: string
  id: number
  logo: string
}

export type TTwitterAccountDetails = {
  user_id: number
  screen_name: string
}

export type TProjectSocialTwitter = {
  project_id: number
  social_network_id: number
  social_network: SOCIAL_NETWORK
  account_details: TTwitterAccountDetails
  token_expires_at: number
  id: number
  logo: string
}

export type TCategory = {
  id: number
  name: string
}

export type TPage = {
  id: number
  category: string
  category_list: TCategory[]
  name: string
  tasks: string[]
  logo: string
}

export type TGetFacebookOrInstagramAuthorizedPagesPayload = {
  project_id: number
  token: string
}

export type TDeleteConnectedSocialAccountPayload = {
  project_id: number
  social: SOCIAL_NETWORK
}

export type TPostChoosePageFromTheListReturnedByGetFacebookAuthorizedPagesPayload = {
  project_id: number
  page_id: string
}

export type TGetLinkedinAuthorizationLinkPayload = {
  project_id: number
  callback_url: string
}

export type TGetLinkedinAuthorizedPagesPayload = {
  code: string
  state: string
}

export type TPostChoosePageFromTheListReturnedByGetLinkedinAuthorizedPagesPayload = {
  project_id: number
  organization: string
}

export type TGetTwitterAuthorizationLinkResponsePayload = {
  project_id: number
  callback_url: string
}

export type TPostSetTwitterUserAccessTokenPayload = {
  oauth_token: string
  oauth_verifier: string
}

export type TGetProjectIdLinkedToTwitterRequestOauthToken = {
  oauth_token: string
}

export type TGetDailyInsightsBySocialNetworkAndMetricPayload = {
  social_network: SOCIAL_NETWORK
  project_id: number
  metrics: string
  from: string
  to: string
  interval?: string
}

export type TSaveProjectSettingsPayload = {
  project_id: number
  settings: {
    name: SETTING_NAME
    value: any
  }[]
}

export type TGetRemoveUserRolesFromProjectPayload = {
  project_id: string
  user_id: string
}

export type TGetSummaryInsightsBySocialNetworkAndMetricPayload = {
  social_network: SOCIAL_NETWORK
  project_id: number
  metrics: string
}

export type TUpdateUserSettingPayload = {
  project_id:number,
  user_id:number,
  payload:TUserSetting
}